var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3326 27.2C15.6699 27.2 15.1326 26.6627 15.1326 26L15.1326 8.97928L8.79761 15.6317C8.33826 16.1094 7.57861 16.1243 7.10088 15.665C6.62316 15.2056 6.60826 14.4459 7.06761 13.9682L15.4676 5.16822C15.6939 4.93293 16.0062 4.79995 16.3326 4.79995C16.659 4.79995 16.9714 4.93293 17.1976 5.16822L25.5976 13.9682C26.057 14.4459 26.0421 15.2056 25.5643 15.665C25.0866 16.1243 24.327 16.1094 23.8676 15.6317L17.5326 8.97928L17.5326 26C17.5326 26.6627 16.9954 27.2 16.3326 27.2Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.cc76067dac4929507454bbc59d0ba15e.svg";
export { ForwardRef as ReactComponent };